import {post_request} from "../axiosFun"

//查询区域计划列表
export const get_regionPlan_list = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            task_name:params.task_name,
            car_id:params.car_id,
            page:params.page,
            size:params.limit
        }
    }
    return post_request("/web/area_plan/get_list",params)
};
//添加中绑定区域车辆的下拉列表
export const get_area_cars_on_inserting = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
        }
    }
    return post_request("/web/area_plan/get_area_cars_on_inserting",params)
}
//添加中绑定区域线路的下拉列表
export const get_area_lines = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
        }
    }
    return post_request("/web/area_plan/get_area_lines",params)
}
//添加区域计划
export const get_regionPlan_add = (params) => {
    params = {
        row:{
            task_name:params.task_name,
            area_id:window.localStorage.getItem("area_id"),
            car_id:params.car_carry,
            line_id:params.line_name,
            start_time:params.time_upend[0],
            end_time:params.time_upend[1],
            count_line:params.count_line
        }
    }
    return post_request("/web/area_plan/add",params)
}
//获取单条数据
export const get_regionPlan_one = (params) => {
    params = {
        row:{
            id:params
        }
    }
    return post_request("/web/area_plan/get_one",params)
}
//修改区域计划
export const get_regionPlan_edit = (params) => {
    params = {
        row:{
            task_name:params.task_name,
            id:params.id,
            area_id:window.localStorage.getItem("area_id"),
            car_id:params.car_id,
            line_id:params.line_id,
            start_time:params.time_upend[0],
            end_time:params.time_upend[1],
            count_line:params.count_line
        }
    }
    return post_request("/web/area_plan/edit",params)
}
//修改中绑定车辆的下拉列表
export const get_area_cars_on_updating = (params) => {
    params = {
        row:{
            area_id:window.localStorage.getItem("area_id"),
            car_id:params
        }
    }
    return post_request("/web/area_plan/get_area_cars_on_updating",params)
}
//删除计划
export const get_regionPlan_del = (params) => {
    params = {
        row:{
            id:params
        }
    }
    return post_request("/web/area_plan/del",params)
}



// WEBPACK FOOTER //
// ./src/api/region/regionPlan.js